import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { carrierUrls } from "../../URL/ApplicationUrls";
import { sortArrayBy } from "../../Utils/arrays";
import { minutesAsMilliSeconds } from "../../Utils/time";
import { CarrierIdentifier } from "../CarrierIdentifier";

export const useFetchCarriers = () => {
  return useQuery<CarrierIdentifier[], Error>({
    queryKey: "carriers",
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchRateAgreementCarriers(),
    onError: () => toast.error("An error occurred when retrieving the Carriers"),
  });
};

const fetchRateAgreementCarriers = async () => {
  const { data: rateAgreementCarriers } = await axios.get<CarrierIdentifier[]>(
    carrierUrls.base.apiUrl
  );

  sortArrayBy<CarrierIdentifier>({
    values: rateAgreementCarriers,
    keyToSort: "Gsdb",
  });

  return rateAgreementCarriers;
};
